<template>
  <v-tooltip bottom v-if="timestamp">
    <template v-slot:activator="{ on }">
      <span v-on="on">{{ human }}</span>
    </template>
    <span>{{ timestamp | formatDateTime }}</span>
  </v-tooltip>
</template>

<script>
import { formatDuration, intervalToDuration, parseISO } from "date-fns";
export default {
  name: "TimestampWithTooltip",
  props: ["timestamp"],
  computed: {
    human() {
      return formatDuration(
        intervalToDuration({
          start: new Date(),
          end: parseISO(this.timestamp),
        })
      );
    },
  },
};
</script>